import { Alert, Anchor, Stack, Text } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import * as React from 'react';

import { useI18n } from '../../../contexts/I18nProvider';
import { GMA_MEMBER_LOGIN_URL } from '../../../variables/GlobalVariables';

/**
 * Bandeau affiché au-dessus des bulletins quand le salarié possède encore des
 * bulletins déposés sur le coffre-fort GererMesAffaires. Le partenariat a pris
 * fin : ces bulletins ne sont plus consultables ici, mais restent accessibles
 * depuis l'application GererMesAffaires ou depuis leur site.
 */
export default function GmaLegacyPayslipsAlert() {
  const { t } = useI18n();

  return (
    <Alert
      mb="md"
      variant="light"
      color="blue"
      icon={<IconInfoCircle />}
      title={t('gma.legacyPayslipsTitle')}
    >
      <Stack gap="xs" align="flex-start">
        <Text size="sm">{t('gma.legacyPayslipsDesc')}</Text>
        <Anchor
          href={GMA_MEMBER_LOGIN_URL}
          target="_blank"
          rel="noreferrer"
          size="sm"
        >
          {t('gma.legacyPayslipsLink')}
        </Anchor>
      </Stack>
    </Alert>
  );
}
